// @flow

import React from "react";
import { Link } from "react-router-dom";

import { Expandable } from "@reecegroup/styles/dist/react/expandable";
import { MaxDesc } from "../max-desc/index";

import { domainConfig } from "../../domain-config";

export class NewToReece extends React.Component<{}, { expanded: boolean }> {
    state: { expanded: boolean };
    constructor() {
        super();
        this.state = { expanded: false };
    }
    render() {
        return (
            <div className="info-block-account">
                <h3 className="info-block-account__header">
                    New to {domainConfig.short_name} Online?
                </h3>
                <p>Registering for online access is easy. Sign up now!</p>
                <Link to="/register">Register Here</Link>
                <div className="member-benefits-wrapper">
                    <h4 className="member-benefits-wrapper__header">
                        <a
                            id="btn-show-mbenefits"
                            onClick={() =>
                                this.setState(s => ({
                                    expanded: !s.expanded
                                }))
                            }
                        >
                            Why should I sign up?
                            <div className="btn-show-mbenefits-arrow">
                                <i className="zmdi zmdi-chevron-down" />
                            </div>
                        </a>
                    </h4>
                    <Expandable expanded={this.state.expanded}>
                        <MaxDesc
                            {...{
                                shortName: domainConfig.short_name,
                                showPersonalAccount:
                                    domainConfig.login_reece_personal_account,
                                personaAccountBulletPoints:
                                    domainConfig.login_reece_personal_account_bulletpoints,
                                showMaxAccount:
                                    domainConfig.login_reece_max_account,
                                maxAccountBulletPoints:
                                    domainConfig.login_reece_max_account_bulletpoints
                            }}
                        />
                    </Expandable>
                </div>
            </div>
        );
    }
}
